import React, { useEffect, useState } from "react";

import { Link } from "@samskip/frontend-components";
import { useTranslation } from "react-i18next";

import Bubble from "@assets/images/icons/bubble.inline.svg";
import ReadMsg from "@assets/images/icons/read-msg.inline.svg";
import UnreadMsg from "@assets/images/icons/unread-msg.inline.svg";
import { UserLatestNotifications, UserNotification } from "@assets/types";
import { NavMenuUtilities } from "@assets/utilities";
import { Popover } from "@components";
import Menu from "@components/Menu/menu";
import NotificationService from "@services/NotificationService";

const Notifications = () => {
  const { t } = useTranslation();
  const maxNotificationDisplayed = 5;
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] =
    useState<UserLatestNotifications | null>(null);

  const toggleOpen = () => {
    setIsOpen((oldOpen) => !oldOpen);
  };
  const closePopover = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    NotificationService.getLatestNotifications()
      .then((latestNotifications) => {
        setNotifications(latestNotifications);
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, []);

  return (
    <div className="relative">
      <div className="relative cursor-pointer" onClick={toggleOpen}>
        <Bubble
          className={
            notifications?.UnreadCount && notifications?.UnreadCount > 0
              ? "text-warning"
              : "text-neutral-700"
          }
        />
        <span className="absolute top-0.5 left-0 w-full text-neutral-0 text-center text-xs">
          {notifications?.UnreadCount || 0}
        </span>
      </div>
      {isOpen && (
        <Popover onClose={closePopover}>
          <ul>
            {notifications &&
              notifications.Notifications &&
              notifications.Notifications.slice(
                0,
                maxNotificationDisplayed
              ).map((notification: UserNotification) => (
                <Menu.Item
                  className="grid grid-cols-12"
                  color={notification.ReadWeb ? "neutral-700" : "primary"}
                  fontWeight={notification.ReadWeb ? "normal" : "semibold"}
                  href={NavMenuUtilities.constructMainServiceWebLink(
                    `/notifications/${notification.NotificationID}`
                  )}
                  key={notification.NotificationID}
                  lined
                  size="none"
                >
                  <span className="col-span-1 p-3 relative top-1">
                    {notification.ReadWeb ? <ReadMsg /> : <UnreadMsg />}
                  </span>
                  <span className="col-span-11 p-3">{notification.Title}</span>
                </Menu.Item>
              ))}
          </ul>
          <div className="bg-neutral-200 flex justify-between px-3.5 py-2">
            <h3 className="italic">
              {t("LABEL_DISPLAYING")}:{" "}
              {notifications &&
              notifications?.TotalCount < maxNotificationDisplayed
                ? notifications?.TotalCount
                : maxNotificationDisplayed}
              / {notifications?.UnreadCount || 0}
            </h3>
            <Link
              className="italic"
              href={NavMenuUtilities.constructMainServiceWebLink(
                "/notifications"
              )}
            >
              {t("LABEL_DISPLAY_ALL_NOTIFICATIONS")}
            </Link>
          </div>
        </Popover>
      )}
    </div>
  );
};

export default Notifications;
